import { useEffect, useState } from 'react';

// Shared helpers for the "Du följer" section, the live highlight and the Mina page.
// Pure functions where possible so they can be unit tested without a browser.

export const FOLLOW_FIRST_KEY = 'sports-hq-follow-first';
export const MINA_URL = '/matches/?vy=mina';

// Live = playing (2) or intermission (3) in every sport adapter.
export const isLiveGame = (game) => [2, 3].includes(Number(game?.status?.status_id));

const clock = (value) => {
  const parts = /^(\d{1,2}):(\d{2})$/.exec(value || '');
  return parts && Number(parts[1]) < 24 && Number(parts[2]) < 60 ? Number(parts[1]) * 60 + Number(parts[2]) : Infinity;
};

// "Det jag följer först i listorna": on by default, off only when explicitly set to 0.
export function followFirstEnabled() {
  try { return (window.SportsHQSettings || window.localStorage).getItem(FOLLOW_FIRST_KEY) !== '0'; } catch { return true; }
}

// Followed games first: live games first, then by start time; the original order breaks ties.
export function splitFollowed(games, isFollowed) {
  const followed = [], rest = [];
  games.forEach((game, index) => (isFollowed(game) ? followed : rest).push({ game, index }));
  followed.sort((a, b) => (isLiveGame(b.game) - isLiveGame(a.game)) || (clock(a.game.time) - clock(b.game.time) || 0) || a.index - b.index);
  return { followed: followed.map((row) => row.game), rest: rest.map((row) => row.game) };
}

export const countLabel = (games, teams) => {
  const game = games === 1 ? 'match' : 'matcher';
  return games || teams ? `${games} ${game} · ${teams} lag` : 'Du följer inget än.';
};

// Re-render when the settings state (profile switch) or any follow changes.
export function useFollowSettingsVersion() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const bump = () => setVersion((value) => value + 1);
    window.addEventListener('sports-hq-follows-change', bump);
    window.addEventListener('sports-hq-settings-state', bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener('sports-hq-follows-change', bump);
      window.removeEventListener('sports-hq-settings-state', bump);
      window.removeEventListener('storage', bump);
    };
  }, []);
  return version;
}
